export function getUrlParams(): any {
  return Object.fromEntries(new URLSearchParams(window.location.search));
}
